import TextField, { TextFieldProps } from '@material-ui/core/TextField';
import clsx from 'clsx';
import styles from './styles.module.css';

type Props = TextFieldProps & {
  className?: string;
  placeholder?: string;
  errorMessage?: string;
};

const TextFieldBase = ({ className, placeholder = '', error, errorMessage, ...restProps }: Props) => {
  return (
    <TextField
      className={clsx(styles.input, className && className)}
      variant="outlined"
      fullWidth
      placeholder={placeholder}
      error={error}
      helperText={errorMessage}
      {...restProps}
    />
  );
};

export default TextFieldBase;
